import { Component, Inject, OnInit } from '@angular/core';
import { DateAdapter, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import * as moment from 'moment';
import { BillingService } from '../../services/billing.service';
import { ClientService } from '../../services/client.service';
import { NotifierService } from '../../shared/notifier/notifier.service';
import * as fileSaver from 'file-saver';

@Component({
  selector: 'app-report-billing-detail',
  templateUrl: 'report-billing-detail.component.html',
  styleUrls: ['report-billing-detail.component.scss'],
  providers: [BillingService, ClientService],
})
export class ReportBillingDetailComponent implements OnInit {
  fechaInicio: any;
  fechaFinal: any;
  opcionSelect: number = 1;
  selectedClientId: any;
  clientList = [];
  filtronombrecliente;
  filteredOptions1 = '';

  constructor(
    private billingService: BillingService,
    private clientService: ClientService,
    public dialogRef: MatDialogRef<ReportBillingDetailComponent>,
    private notifierService: NotifierService,
    @Inject(MAT_DIALOG_DATA) public dataInjected: any,
    private dateAdapter: DateAdapter<Date>
  ) {
    this.dateAdapter.setLocale('en-GB');
  }

  onClientSelected(selectedUsuario) {
    this.selectedClientId = selectedUsuario.id;
  }

  getClientes(event?) {
    if (event) {
      this.filteredOptions1 = event.target.value;
    }
    this.clientService
      .getClientByName(this.filteredOptions1.replace(/ /g, ''))
      .subscribe(
        (result) => {
          this.clientList = result as Array<any>;
          //this.selectedClientId = this.clientList[0].id;
        },
        (error) => {
          console.log('error', error);
        }
      );
  }

  ngOnInit() {
    if (!this.dataInjected.clientst) {
      this.clientService.getClientListBilling().subscribe(
        (result: Array<any>) => {
          this.clientList = result;
        },
        (error) => {
          this.notifierService.systemNotify({
            title: 'Error',
            message: error.message,
            type: 'error',
          });
        }
      );
    }

    console.log('INJECTED: ', this.dataInjected);
  }

  downloadReport() {
    if (this.opcionSelect == 1) {
      this.reportByDates();
    } else {
      if (this.opcionSelect == 2) {
        this.reportByClient();
      } else {
        this.notifierService.systemNotify({
          title: 'Error',
          message: 'Seleccione una opción válida',
          type: 'error',
        });
        return;
      }
    }
  }

  reportByDates() {
    if (
      this.fechaInicio === undefined ||
      this.fechaInicio === null ||
      this.fechaInicio === '' ||
      this.fechaFinal === undefined ||
      this.fechaFinal === null ||
      this.fechaFinal === ''
    ) {
      this.notifierService.systemNotify({
        title: 'Error',
        message: 'Seleccione un rango de fechas válido',
        type: 'error',
      });
      return;
    }

    const fechaInicio = moment(this.fechaInicio).format('YYYY-MM-DD');
    const fechaFinal = moment(this.fechaFinal).format('YYYY-MM-DD');

    if (moment(fechaInicio).isAfter(fechaFinal)) {
      this.notifierService.systemNotify({
        title: 'Error',
        message: 'La fecha inicial no puede ser mayor a la fecha final',
        type: 'error',
      });
      return;
    }

    console.log('Fecha inicio: ', fechaInicio);
    console.log('Fecha final: ', fechaFinal);

    this.notifierService.systemNotify({
      title: 'Descargando',
      message: 'Descargando reporte detalle en rango de fechas',
      type: 'info',
    });

    this.billingService
      .getReportBillingDetailByDates(fechaInicio, fechaFinal)
      .subscribe((result) => {
        let blob :any = result;
        let fileName = `report_billing_detail_${fechaInicio}_${fechaFinal}`;
        fileSaver.saveAs(blob, fileName);
        this.notifierService.systemNotify({
          title: 'Descarga completada',
          message:
            'Reporte detalle en rango de fechas descargado correctamente',
          type: 'success',
        });
      }, (error) => {
        if (error.status == 400) {
          this.notifierService.systemNotify({
            title: 'Error',
            message: 'No se encontraron facturaciones en ese rango de fechas',
            type: 'error',
          });
        } else {
          this.notifierService.systemNotify({
            title: 'Error',
            message: 'Sucedió un error al descargar el reporte',
            type: 'error',
          });
        }
      });
  }

  reportByClient() {
    if (
      this.selectedClientId == null ||
      this.selectedClientId == undefined ||
      this.selectedClientId == '' ||
      this.selectedClientId <= 0
    ) {
      this.notifierService.systemNotify({
        title: 'Error',
        message: 'Seleccione un cliente válido',
        type: 'error',
      });
      return;
    }

    console.log('Cliente: ', this.selectedClientId);

    this.notifierService.systemNotify({
      title: 'Descargando',
      message: 'Descargando reporte detalle por cliente',
      type: 'info',
    });

    this.billingService
      .getReportBillingDetailByClient(this.selectedClientId)
      .subscribe((result) => {
        let blob :any = result;
        let fileName = `report_billing_detail_client_${this.selectedClientId}`;
        fileSaver.saveAs(blob, fileName);
        this.notifierService.systemNotify({
          title: 'Descarga completada',
          message: 'Reporte detalle por cliente descargado correctamente',
          type: 'success',
        });
      }, (error) => {

        if (error.status == 400) {
          this.notifierService.systemNotify({
            title: 'Error',
            message: 'No se encontraron facturaciones para el cliente seleccionado',
            type: 'error',
          });
        } else {
          this.notifierService.systemNotify({
            title: 'Error',
            message: 'Sucedió un error al descargar el reporte',
            type: 'error',
          });
        }

      });
  }
}



// WEBPACK FOOTER //
// ./src/app/system/billing/report-billing-detail/report-billing-detail.component.ts